export default "__VITE_ASSET__face9911__"